import React from "react";
import "./SampleCustomerComponent.scss";

function SampleCustomerComponent() {
  return <div class="sample">Sample Box</div>;
}

export default SampleCustomerComponent;
